import style from './style';
var boxShadow = style({
  prop: 'boxShadow',
  themeKey: 'shadows'
});
export default boxShadow;


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/system/esm/shadows.js
// module id = 1731
// module chunks = 121